<script>
export default {
  name: 'OverlayPageLink',
  props: {
    type: String,
    label: String,
    page: Object
  },
  methods: {
    onClick(event) {
      event.preventDefault();
      this.$store.dispatch('openOverlayPage', {
        component: 'InfoPage',
        props: {
          slug: this.page.post_name
        }
      });
    }
  }
};
</script>

<template>
  <a
    href="#"
    v-on:click="onClick($event)"
    class="overlay-page-link"
    v-bind:class="[
      `overlay-page-link--${type}`,
      { 'read-more': type === 'read-more' },
    ]">{{ label }}</a>
</template>

<style lang="scss">
.overlay-page-link {
  color: $color-secondary;
}

.overlay-page-link.overlay-page-link--read-more {
  font-size: 1.76rem;

  &::before {
    content: '';
    display: inline-block;
    width: 1em;
    height: 0.8em;
    background-size: 1.2rem;
  }
}
</style>
